// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery } from '@tanstack/react-query';
import { useUtilityOperatorApiClient } from '../../contexts/UtilityOperatorApiContext';

export const useGetAllInstrumentConfigurations = () => {
  const u = useUtilityOperatorApiClient();
  return useQuery({
    queryKey: ['getInstrumentConfigurations'],
    queryFn: () => u.getAllInstrumentConfigurations(),
    refetchInterval: false,
  });
};
